export class SalesAgent {

    constructor(
        public name: string,
        public id: number
    ){}
}
